module.exports = __webpack_public_path__ + "img/Office2@2x.png";